import React, { ChangeEvent, useEffect, useState } from 'react';
import { Feedback, fieldFeedbackContainer } from '@noths/polaris-client-ribbons-design-system';

import { QUANTITY_COPY, RANGE_OVERFLOW_COPY } from './constants/copy';
import * as styles from './styles';

interface QuantityProps {
  defaultValue?: string | number | readonly string[];
  maxValue?: number;
  minValue?: number;
  onChange: (value: string, valid: boolean) => void;
}

export const ERROR_ID = 'quantity__error';
export const QUANTITY_ID = 'quantity';

export const Quantity = ({
  defaultValue = 1,
  maxValue = 10000,
  minValue = 1,
  onChange,
}: QuantityProps) => {
  const [value, setValue] = useState(defaultValue);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (value !== defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      setValue('1');
      onChange('1', true);
    }
  };

  const handleChange = ({ target: { value, validity } }: ChangeEvent<HTMLInputElement>) => {
    const validationError =
      parseInt(value) > maxValue ? `${RANGE_OVERFLOW_COPY} ${maxValue}` : null;

    if (validity.rangeUnderflow) {
      return;
    }

    setValue(value);
    setErrorMessage(validationError);
    onChange(value, !validationError);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === '.') {
      e.preventDefault();
    }
  };

  return (
    <div css={styles.quantityContainer} data-has-error={!!errorMessage}>
      <label css={styles.quantityLabel} htmlFor={QUANTITY_ID}>
        {QUANTITY_COPY}
      </label>
      <input
        aria-describedby={ERROR_ID}
        aria-invalid={!!errorMessage}
        aria-required
        onBlur={handleBlur}
        onChange={handleChange}
        css={styles.quantityInput}
        type="number"
        id={QUANTITY_ID}
        min={minValue}
        step="1"
        onKeyPress={handleKeyPress}
        value={value}
      />
      <div id={ERROR_ID} css={fieldFeedbackContainer}>
        {errorMessage && <Feedback value={errorMessage} error={!!errorMessage} iconAlign="right" />}
      </div>
    </div>
  );
};
